import {
  EMPLOYEE_STAFF_ON_CLICK_EXPORT,
  EMPLOYEE_STAFF_ON_CLICK_INVITE_STAFF,
  EMPLOYEE_STAFF_ON_CHANGE_KEYWORD,
  EMPLOYEE_STAFF_LIST_STAFF_REQUEST,
  EMPLOYEE_STAFF_LIST_ROLES_REQUEST,
  EMPLOYEE_STAFF_PAGE_REQUEST,
  SUBMITTING_GET_EMPLOYEES,
  SUBMITTING_CREATE_EMPLOYEE,
  SUBMITTING_UPDATE_EMPLOYEE,
  EMPLOYEE_STAFF_ON_CLICK_CANCEL,
  EMPLOYEE_STAFF_ON_CLICK_ROW,
  EMPLOYEE_STAFF_LIST_OUTLET_REQUEST,
  EMPLOYEE_STAFF_ON_CONFIRM_ASSIGN_OUTLET,
  EMPLOYEE_STAFF_ON_CLICK_ASSIGN_OUTLET,
  EMPLOYEE_STAFF_ON_CANCEL_ASSIGN_OUTLET,
  EMPLOYEE_STAFF_ON_SUBMIT_FORM,
  EMPLOYEE_STAFF_RESEND_INVITATION,
  EMPLOYEE_STAFF_ON_CANCEL_DELETE_EMPLOYEE,
  EMPLOYEE_STAFF_ON_CONFIRM_DELETE_EMPLOYEE,
  EMPLOYEE_STAFF_ON_CLICK_DELETE_EMPLOYEE,
  EMPLOYEE_STAFF_ON_CLICK_RESEND_INVITATION,
  EMPLOYEE_STAFF_ON_CLICK_RESEND_WITH_VALID_CAPTCHA,
  EMPLOYEE_STAFF_ON_CANCEL_RESEND,
  EMPLOYEE_STAFF_LIST_PERMISSIONS_REQUEST
} from 'actions/employees/staff/constants'
import {
  openRightColumn,
  closeRightColumn,
  setEmployeeDetail,
  setEmployees,
  listStaffRequest,
  listOutletRequest,
  listRolesRequest,
  setSubmitting,
  setOutlets,
  setRoles,
  showAssignOutletModal,
  hideAssignOutletModal,
  showEmployeeDeleteModal,
  hideEmployeeDeleteModal,
  setResendCaptchaEmail,
  showResendCaptchaModal,
  hideResendCaptchaModal,
  resendInvitation,
  setCanAccessRole,
  listPermissionRequest,
  showPinRequiredModal,
  setPinRequiredModal
} from 'actions/employees/staff'
import {takeLatest, put, call} from 'redux-saga/effects'
import {delay} from 'redux-saga'
import * as actNotif from 'actions/notifications'
import {showProgressBar, hideProgressBar} from 'actions'
import {initialize, reset, change} from 'redux-form'
import * as apiOutlets from 'api/outlets'
import * as apiRoles from 'api/roles'
import * as apiEmployees from 'api/employees'
import sort from 'lodash/sortBy'
import * as mpStaff from 'mixpanel/employees/staff'
import {deleteEmployeeServiceV1} from 'api/employees/employees'
import moment from 'moment'
import download from 'downloadjs'

const MAX_RESEND_QUOTA = 2

export function getQuotaExpiredDate () {
  return moment().add(1, 'd').toDate()
}

function quotaCookieKey ({email}) {
  return `__rsd_email_quota_${email}`
}

export function getQuota ({email}) {
  const key = quotaCookieKey({email})
  const quota = Cookies.get(key)
  const expires = getQuotaExpiredDate()
  if (quota === undefined) {
    Cookies.set(key, MAX_RESEND_QUOTA, {expires})
    return MAX_RESEND_QUOTA
  } else {
    return parseInt(quota)
  }
}

export function decrementQuota ({email}) {
  const key = quotaCookieKey({email})
  const value = Cookies.get(key)
  const quota = parseInt(value) || 0
  const expires = getQuotaExpiredDate()
  if (quota > 0) {
    Cookies.set(key, quota - 1, {expires})
  } else {
    Cookies.set(key, 0, {expires})
  }
}

export function * onChangeKeywordFlow (request) {
  const {payload: {keyword, user}} = request
  // debounce user input
  yield call(delay, 300)
  yield put(closeRightColumn())
  yield put(reset('staff'))
  yield put(setEmployeeDetail({employee: null}))
  yield put(listStaffRequest({keyword, user, submitFlag: true}))
}

export function * resendInvitationFlow (request) {
  let {payload: {email}} = request
  try {
    yield call(decrementQuota, {email})
    yield put(showProgressBar())
    yield call(apiEmployees.resendInvitation, {pending_employee_email: email}, {})
    // Please git blame api.js at line 2681 on moka-rails to see why this message is hard-coded
    yield put(actNotif.success('Employee invitation sent!'))
  } catch (error) {
    yield put(actNotif.error(error.message))
  } finally {
    yield put(hideProgressBar())
  }
}

export function * onClickExportFlow (request) {
  const {employees, user} = request.payload
  try {
    yield put(showProgressBar())
    let data = 'First Name,Last Name,Role,Email,Email Status,Phone,Outlet'
    employees.forEach((e) => {
      if (data) {
        data = `${data}\n`
      }
      const phone = (e.phone) ? `0${e.phone}` : ``
      const emailConfirmed = (e.is_email_confirmed) ? 'Verified' : 'Waiting for Verification'
      data = `${data}${e.first_name},${e.last_name},${e.role.name},${e.email},${emailConfirmed},${phone},"`
      for (let i = 0; i < e.outlets.length; i++) {
        const o = e.outlets[i]
        if (i > 0) {
          data = `${data}, ${o.name}`
        } else {
          data = `${data}${o.name}`
        }
      }
      data = `${data}"`
    })
    download(data, `Export-Employee-${user.business.name}.csv`)
    // let data = []
    // const response = yield call(apiEmployees.getExportEmployeesServiceV1,{})
  } catch (error) {
    yield put(actNotif.error(error.message))
  } finally {
    yield put(hideProgressBar())
  }
}

export function * onClickInviteStaffFlow (request) {
  yield put(setEmployeeDetail({employee: null}))
  yield put(initialize('staff', {
    email: '',
    first_name: '',
    last_name: '',
    photo_url: '',
    description: '',
    outlets: [],
    phone: ''
  }))
  yield put(openRightColumn())
}

export function * listStaffRequestFlow (request) {
  const {payload: {keyword, submitFlag, user}} = request
  try {
    yield put(showProgressBar())
    if (submitFlag) {
      yield put(setSubmitting({submitting: SUBMITTING_GET_EMPLOYEES}))
    }
    yield put(setEmployees({employees: []}))
    const response = yield call(apiEmployees.getEmployeesServiceV1, {params: {deep: true, keyword, include_me: user.is_manager}})
    // prevent NULL from server, encapsulate it first
    yield put(setEmployees({employees: sort(response.data.employees, (d) => [`${d.first_name}`.toLowerCase(), `${d.last_name}`.toLowerCase()])}))
  } catch (error) {
    yield put(actNotif.error(error.message))
  } finally {
    if (submitFlag) {
      yield put(setSubmitting({submitting: null}))
    }
    yield put(hideProgressBar())
  }
}

export function * listOutletRequestFlow (request) {
  try {
    yield put(showProgressBar())
    const response = yield call(apiOutlets.outlets)
    const outlets = response.data
    yield put(setOutlets({outlets}))
  } catch (error) {
    yield put(actNotif.error(error.message))
  } finally {
    yield put(hideProgressBar())
  }
}

export function * listRolesRequestFlow (request) {
  try {
    yield put(showProgressBar())
    const response = yield call(apiRoles.getRolesV1, {params: {}})
    const roles = response.data.roles.map((r) => { return {id: r.id, name: r.name} })
    yield put(setRoles({roles: sort(roles, 'name')}))
  } catch (error) {
    yield put(actNotif.error(error.message))
  } finally {
    yield put(hideProgressBar())
  }
}

export function * listPermissionRequestFlow (request) {
  const {payload: {userId}} = request
  try {
    yield put(showProgressBar())
    const response = yield call(apiEmployees.getPermission, {userId, params: {}})
    let canAccessRole = false
    response.data.permissions.forEach((p) => {
      canAccessRole = canAccessRole || (p.access === 'Back-office' && p.menu === 'Employees' && p.sub_menu === 'Role')
    })
    yield put(setCanAccessRole({canAccessRole}))
  } catch (error) {
    yield put(actNotif.error(error.message))
  } finally {
    yield put(hideProgressBar())
  }
}

export function * pageRequestFlow (request) {
  const {payload: {user}} = request
  yield put(closeRightColumn())
  yield put(setEmployees({employees: []}))
  yield put(setEmployeeDetail({employee: null}))
  // since we want to show loading spinner until ALL request are called
  // we cannot use `put` action since it is async
  // instead we call saga effects directly with no submit flag
  // and we set submit flag manually here
  yield put(setSubmitting({submitting: 'page'}))
  yield call(listOutletRequestFlow, listOutletRequest())
  yield call(listRolesRequestFlow, listRolesRequest())
  yield call(listStaffRequestFlow, listStaffRequest({keyword: '', user, submitFlag: false}))
  yield call(listPermissionRequestFlow, listPermissionRequest({userId: user.id}))
  yield put(setSubmitting({submitting: null}))
}

export function * onClickRowFlow (request) {
  const {payload: {employee}} = request
  yield put(setEmployeeDetail({employee}))
  yield put(initialize('staff', {
    id: employee.id || '',
    description: employee.description || '',
    email: employee.email || '',
    first_name: employee.first_name || '',
    last_name: employee.last_name || '',
    outlets: employee.outlets.map((o) => `${o.id}`),
    phone: employee.phone || '',
    photo_url: employee.photo_url || '',
    pin: employee.pin || '',
    assign_pin: !!employee.pin,
    role_id: `${employee.role.id}`
  }))
  yield put(openRightColumn())
}

export function * onClickCancelFlow (request) {
  yield put(closeRightColumn())
  yield put(setEmployeeDetail({employee: null}))
}

export function * onClickAssignOutletFlow (request) {
  yield put(showAssignOutletModal())
}

export function * onConfirmAssignOutletFlow (request) {
  const {payload: {assignedOutletIds}} = request
  yield put(change('staff', 'outlets', assignedOutletIds))
  yield put(hideAssignOutletModal())
}

export function * onCancelAssignOutletFlow (request) {
  yield put(hideAssignOutletModal())
}

export function * onSubmitFormFlow (request) {
  const {payload: {values, previousEmployees, outlets, role}} = request
  if (values.id) {
    mpStaff.editStaff({employee: values, outlets, role})
    yield put(setSubmitting({submitting: SUBMITTING_UPDATE_EMPLOYEE}))
  } else {
    mpStaff.inviteStaff({employee: values, outlets, role})
    yield put(setSubmitting({submitting: SUBMITTING_CREATE_EMPLOYEE}))
  }
  if (!values.outlets || values.outlets.length === 0) {
    yield put(showAssignOutletModal())
  } else if (values.assign_pin && !values.pin) {
    yield put(actNotif.error('Please make sure the PIN has been filled'))
  } else if (!values.role_id) {
    yield put(actNotif.error('Role is required for each of the staff'))
  } else {
    const data = {
      email: values.email,
      first_name: values.first_name,
      last_name: values.last_name,
      phone: values.phone,
      role_id: values.role_id,
      description: values.description,
      photo_url: values.photo_url,
      outlets: values.outlets
    }
    if (values.assign_pin) {
      data.auth_code = values.pin
    } else {
      data.auth_code = ''
      values.pin = ''
    }
    let shouldSendEmail = false
    let successMessage = ''
    try {
      yield put(showProgressBar())
      let employeeDetail
      let employees = []
      // map outlet
      const assignedOutletIds = {}
      values.outlets.forEach((oid) => { assignedOutletIds[oid] = true })
      const assignedOutlets = outlets.filter((outlet) => {
        return assignedOutletIds.hasOwnProperty(outlet.id)
      })

      if (values.id) {
        yield call(apiEmployees.putEmployeesServiceV1, {data, params: {}, id: values.id})
        previousEmployees.forEach((pe) => {
          if (pe.id === values.id) {
            employeeDetail = {
              ...pe,
              email: values.email,
              first_name: values.first_name,
              last_name: values.last_name,
              phone: values.phone,
              role: {
                id: values.role_id,
                name: role.name
              },
              description: values.description,
              photo_url: values.photo_url,
              outlets: assignedOutlets,
              pin: values.pin
            }
            if (pe.email !== values.email) {
              shouldSendEmail = true
            }
            employees.push(employeeDetail)
          } else {
            employees.push(pe)
          }
        })
        successMessage = 'Employee was successfully saved'
      } else {
        const response = yield call(apiEmployees.postEmployeesServiceV1, {data, params: {}})
        employeeDetail = {
          ...values,
          id: response.data.user_id,
          outlets: assignedOutlets,
          role: {
            id: role.id,
            name: role.name
          }
        }
        if (values.assign_pin) {
          employeeDetail.pin = values.pin
        } else {
          employeeDetail.pin = ''
        }
        employees = [employeeDetail, ...previousEmployees]
        shouldSendEmail = true
        successMessage = 'Employee invitation sent!'
      }
      if (shouldSendEmail) {
        yield call(apiEmployees.resendInvitation, {pending_employee_email: values.email}, {})
      }
      yield put(setEmployees({employees}))
      yield put(setEmployeeDetail({employee: employeeDetail}))
      yield put(initialize('staff', {...values, id: employeeDetail.id}))
      yield put(actNotif.success(successMessage))
    } catch (error) {
      if (error.data && error.data.error && error.data.error.code === 8) {
        yield put(setPinRequiredModal({message: error.data.error.user_message}))
        yield put(showPinRequiredModal())
      } else {
        yield put(actNotif.error(error.message))
      }
    } finally {
      yield put(hideProgressBar())
    }
  }
  yield put(setSubmitting({submitting: null}))
}

export function * onCancelDeleteEmployeeFlow () {
  yield put(hideEmployeeDeleteModal())
}

export function * onConfirmDeleteEmployeeFlow (request) {
  const {payload: {employee, previousEmployees}} = request
  mpStaff.deleteStaff()
  try {
    yield put(showProgressBar())
    yield call(deleteEmployeeServiceV1, {params: {}, id: employee.id})
    const employees = []
    previousEmployees.forEach((e) => {
      if (e.id !== employee.id) {
        employees.push(e)
      }
    })
    yield put(setEmployees({employees}))
    yield put(setEmployeeDetail({employee: null}))
    yield put(closeRightColumn())
    yield put(actNotif.success('Employee was successfully deleted'))
  } catch (error) {
    if (error.data && error.data.error && error.data.error.code === 8) {
      yield put(setPinRequiredModal({message: error.data.error.user_message}))
      yield put(showPinRequiredModal())
    } else {
      yield put(actNotif.error(error.message))
    }
  } finally {
    yield put(hideProgressBar())
  }
  yield put(hideEmployeeDeleteModal())
}

export function * onClickDeleteEmployeeFlow () {
  yield put(showEmployeeDeleteModal())
}

export function * onClickResendInvitationFlow (request) {
  const {payload: {email}} = request
  const quota = yield call(getQuota, {email})
  if (quota) {
    yield put(resendInvitation({email}))
  } else {
    yield put(setResendCaptchaEmail({email}))
    yield put(showResendCaptchaModal())
  }
}

export function * onCancelResendFlow (request) {
  yield put(setResendCaptchaEmail({email: null}))
  yield put(hideResendCaptchaModal())
}

export function * onClickResendWithValidCaptchaFlow (request) {
  const {payload: {email}} = request
  yield put(hideResendCaptchaModal())
  yield put(resendInvitation({email}))
  yield put(setResendCaptchaEmail({email: null}))
}

export default function * saga () {
  yield takeLatest(EMPLOYEE_STAFF_ON_CHANGE_KEYWORD, onChangeKeywordFlow)
  yield takeLatest(EMPLOYEE_STAFF_ON_CLICK_EXPORT, onClickExportFlow)
  yield takeLatest(EMPLOYEE_STAFF_ON_CLICK_INVITE_STAFF, onClickInviteStaffFlow)
  yield takeLatest(EMPLOYEE_STAFF_LIST_STAFF_REQUEST, listStaffRequestFlow)
  yield takeLatest(EMPLOYEE_STAFF_LIST_ROLES_REQUEST, listRolesRequestFlow)
  yield takeLatest(EMPLOYEE_STAFF_PAGE_REQUEST, pageRequestFlow)
  yield takeLatest(EMPLOYEE_STAFF_ON_CLICK_CANCEL, onClickCancelFlow)
  yield takeLatest(EMPLOYEE_STAFF_ON_CLICK_ROW, onClickRowFlow)
  yield takeLatest(EMPLOYEE_STAFF_LIST_OUTLET_REQUEST, listOutletRequestFlow)
  yield takeLatest(EMPLOYEE_STAFF_ON_CLICK_ASSIGN_OUTLET, onClickAssignOutletFlow)
  yield takeLatest(EMPLOYEE_STAFF_ON_CONFIRM_ASSIGN_OUTLET, onConfirmAssignOutletFlow)
  yield takeLatest(EMPLOYEE_STAFF_ON_CANCEL_ASSIGN_OUTLET, onCancelAssignOutletFlow)
  yield takeLatest(EMPLOYEE_STAFF_ON_SUBMIT_FORM, onSubmitFormFlow)
  yield takeLatest(EMPLOYEE_STAFF_RESEND_INVITATION, resendInvitationFlow)
  yield takeLatest(EMPLOYEE_STAFF_ON_CANCEL_DELETE_EMPLOYEE, onCancelDeleteEmployeeFlow)
  yield takeLatest(EMPLOYEE_STAFF_ON_CONFIRM_DELETE_EMPLOYEE, onConfirmDeleteEmployeeFlow)
  yield takeLatest(EMPLOYEE_STAFF_ON_CLICK_DELETE_EMPLOYEE, onClickDeleteEmployeeFlow)
  yield takeLatest(EMPLOYEE_STAFF_ON_CLICK_RESEND_INVITATION, onClickResendInvitationFlow)
  yield takeLatest(EMPLOYEE_STAFF_ON_CLICK_RESEND_WITH_VALID_CAPTCHA, onClickResendWithValidCaptchaFlow)
  yield takeLatest(EMPLOYEE_STAFF_ON_CANCEL_RESEND, onCancelResendFlow)
  yield takeLatest(EMPLOYEE_STAFF_LIST_PERMISSIONS_REQUEST, listPermissionRequestFlow)
}



// WEBPACK FOOTER //
// ./app/sagas/employees/staff.js